import { Skeleton } from "@particles/index"

import { UserAvatarStack } from "@molecules"

import { useJobPreviewCard } from "@pages/Jobs/JobList/views/JobTimelineView/JobPreviewCard/JobPreviewCard.context"

import { JobPreviewTechniciansListProps } from "./JobPreviewTechniciansList.types"

export default function JobPreviewTechniciansList(props: JobPreviewTechniciansListProps) {
    const { users = [] } = props

    const { isLoading } = useJobPreviewCard()

    if (isLoading && users.length === 0) {
        return <Skeleton width={80} height={20} />
    }

    return <UserAvatarStack limit={3} users={users} avatarSize="xs" variation="stack" />
}
